import { Method } from 'axios';
import { apiCall } from '@/utility/api/apiUtils';
import { API_METHOD_POST, API_CREATE_TASK } from '@/constants/apiConstants';
import { generateHash } from '@/utility/auth/generateHashValue';

export interface CreateTaskPayload {
  phase_uuid: string; // empty string allowed per API contract
  products_services_uuid: string;
  enquiry_uuid?: string; // optional for schedule phase tasks
  name: string;
  description: string;
}

export interface CreateTaskResponse {
  status: string;
  data?: {
    uuid: string;
    task_number: string;
    name: string;
    description: string;
    job_product_id: number;
    job_product_uuid: string;
    phase_id: number | null;
    phase_uuid: string | null;
    status: number;
    created_at: string;
    updated_at: string;
    sections: any[];
  };
  message?: string;
}

export const createTask = async (
  payload: CreateTaskPayload,
): Promise<CreateTaskResponse> => {
  const method: Method = API_METHOD_POST;
  const url = API_CREATE_TASK;
  const data = payload;

  console.log('Create Task API Call Details:', {
    method,
    url,
    data,
  });

  // Convert JSON object to string for hash generation
  const jsonString = JSON.stringify(data);
  const additionalHeaders = {
    hash: generateHash(jsonString),
  };

  try {
    const response = await apiCall({
      method,
      url,
      data,
      headers: additionalHeaders,
    });
    return response; // Return the response data for further use
  } catch (error) {
    console.error('Create Task API Call Error:', error);
    throw error; // Re-throw the error to be handled by the caller
  }
};
